import { service as request, apiObj } from './request.js'

const urlBase = '/api'

const api = {
  // 首页
  // 获取首页图表数据
  getHomeChart (data) {
    return request({
      url: urlBase + '/chart/data',
      method: 'post',
      data: data
    })
  },
  // 获取首页同步数据
  getHomeSynchronize (search) {
    return request({
      url: urlBase + '/chart/processes?search=' + search,
      method: 'get'
    })
  },
  sendSmsCode (data) {
    return request({
      url: urlBase + '/auth/phone/send_code/' + apiObj(data)
    })
  },
  sendEmailCode (data) {
    return request({
      url: urlBase + '/auth/email/send_code/' + apiObj(data)
    })
  },
  // 获取所有组织
  getGroups () {
    return request({
      url: urlBase + '/groups/'
    })
  },
  putGroup (data) {
    return request({
      url: urlBase + '/group/current',
      method: 'put',
      data: data
    })
  },
  // 切换组织获取新token
  getNewToken (data) {
    return request({
      url: urlBase + '/group/change' + apiObj(data)
    })
  },
  // 获取当前用户的组织
  getUserGroup () {
    return request({
      url: urlBase + '/user/groups/'
    })
  },
  changeCurrentTitle (data) {
    return request({
      url: urlBase + '/user/title/',
      method: 'put',
      data: data
    })
  },
  changeCurrentEmail (data) {
    return request({
      url: urlBase + '/user/email/',
      method: 'put',
      data: data
    })
  },
  changeCurrentPhone (data) {
    return request({
      url: urlBase + '/user/phone/',
      method: 'put',
      data: data
    })
  },
  changeCurrentPassword (data) {
    return request({
      url: urlBase + '/user/password/',
      method: 'put',
      data: data
    })
  },
  changeVersion () {
    return request({
      url: urlBase + '/user/change_version/',
      method: 'put'
    })
  },
  getGroupUsers () {
    return request({
      url: urlBase + '/group/users'
    })
  },
  getEdiGroupUsers (id) {
    return request({
      url: urlBase + '/group/edi?group_id=' + id
    })
  },
  getUserInfo () {
    return request({
      url: urlBase + '/user/current/'
    })
  },
  getUserExist (data) {
    return request({
      url: urlBase + '/user/exist' + apiObj(data),
    })
  },
  login (data) {
    return request({
      url: urlBase + '/auth/login',
      method: 'post',
      data: data
    })
  },
  getCurrentGroup () {
    return request({
      url: urlBase + '/group/current',
      method: 'get',
    })
  },
  createGroup (data) {
    return request({
      url: urlBase + '/group/create',
      method: 'post',
      data: data
    })
  },
  createGroupUserByName (data) {
    return request({
      url: urlBase + '/group/user',
      method: 'post',
      data: data
    })
  },
  deleteGroupUser (data) {
    return request({
      url: urlBase + '/group/user' + apiObj(data),
      method: 'delete'
    })
  },
  changeAlert (data) {
    return request({
      url: urlBase + '/user/alert/',
      method: 'put',
      data: data
    })
  },
  // 新增数据
  postData (data) {
    return request({
      url: urlBase + '/data',
      method: 'post',
      data: data
    })
  },
  // 获取数据列表
  getData (data) {
    return request({
      url: urlBase + '/data' + apiObj(data),
      method: 'get'
    })
  },
  getDataEvenFields (dataID) {
    return request({
      url: urlBase + '/data/' + dataID + '/even_fields',
      method: 'get'
    })
  },
  // 获取数据列表
  getStorageFields (data) {
    return request({
      url: urlBase + '/data/' + data.id + '/get_fields',
      method: 'get'
    })
  },
  // 运行
  runData (id) {
    return request({
      method: 'put',
      url: urlBase + '/do_process/' + id,
      data: {}
    })
  },
  // 获取单个数据列表
  getSignalData (id) {
    return request({
      url: urlBase + '/data/' + id,
      method: 'get'
    })
  },
  // 获取所有执行规则
  getSchedules (data) {
    return request({
      url: urlBase + '/schedules/' + data,
      method: 'get'
    })
  },
  // 新增执行规则
  postSchedules (data) {
    return request({
      url: urlBase + '/schedules',
      method: 'post',
      data
    })
  },
  // 修改执行规则
  putSchedule (id, data) {
    return request({
      url: urlBase + '/schedule/' + id,
      method: 'put',
      data
    })
  },
  // 删除执行规则
  delSchedule (id) {
    return request({
      url: urlBase + '/schedule/' + id,
      method: 'delete'
    })
  },
  // 更新单个数据
  UpdateSignalData (id, data) {
    return request({
      url: urlBase + '/data/' + id,
      method: 'put',
      data: data
    })
  },
  // 删除单个数据
  deleteSignalData (id) {
    return request({
      url: urlBase + '/data/' + id,
      method: 'delete'
    })
  },
  // 修改名称
  UpdateDataName (id, data) {
    return request({
      url: urlBase + '/data/' + id + '/rename/',
      method: 'put',
      data: data
    })
  },
  // 生成数据库字段
  UpdateDBField (id, data) {
    return request({
      url: urlBase + '/execute/get_sql_field',
      method: 'put',
      data: data
    })
  },
  UpdateAPIField (id, data) {
    return request({
      url: urlBase + '/execute/get_api_field',
      method: 'put',
      data: data
    })
  },
  GetSourceData () {
    return request({
      url: urlBase + '/source',
      method: 'get',
    })
  },
  GetTargetData () {
    return request({
      url: urlBase + '/target',
      method: 'get',
    })
  },
  getTransformList (data) {
    return request({
      url: urlBase + '/transaction' + apiObj(data),
      method: 'get'
    })
  },
  getTransform (id) {
    return request({
      url: urlBase + '/transaction/' + id,
      method: 'get'
    })
  },
  runTransform (id) {
    return request({
      method: 'post',
      url: urlBase + '/transaction/' + id + '/run',
    })
  },
  // 删除数据转换
  delTransform (id) {
    return request({
      url: urlBase + '/transaction/' + id,
      method: 'delete'
    })
  },
  PostTransform (data) {
    return request({
      url: urlBase + '/transaction',
      method: 'post',
      data: data
    })
  },
  renameTransform (id, data) {
    return request({
      url: urlBase + '/transaction/' + id + '/rename',
      method: 'put',
      data: data
    })
  },
  PutTransform (data) {
    return request({
      url: urlBase + '/transaction/' + data.id,
      method: 'put',
      data: data
    })
  },
  // 获取process列表
  getProcessList (data) {
    return request({
      url: urlBase + '/processes',
      method: 'post',
      data: data
    })
  },
  // 获取单个process信息
  getProcess (pid) {
    return request({
      url: urlBase + '/process/' + pid
    })
  },
  // 获取trace详情
  getTraces (pid) {
    return request({
      url: urlBase + '/traces/' + pid
    })
  },
  getTrace (tid) {
    return request({
      url: urlBase + '/trace/' + tid
    })
  },
  // 权限
  // 获取权限列表
  getDataAuth (data) {
    return request({
      url: urlBase + '/data_auth/list',
      method: 'post',
      data
    })
  },
  // 修改权限
  postDataAuth (data) {
    return request({
      url: urlBase + '/data_auth',
      method: 'post',
      data
    })
  },
  // agent
  // 获取agent列表
  getAgentList (id) {
    return request({
      url: urlBase + '/project/' + id + '/agents',
      method: 'get'
    })
  },
  // 删除agent
  delAgent (id) {
    return request({
      url: urlBase + '/project/' + id + '/agent',
      method: 'delete'
    })
  },
  // 编辑agent
  putAgent (data, id) {
    return request({
      url: urlBase + '/project/' + id + '/agent',
      method: 'put',
      data
    })
  },
  // 获取agent_key
  getAgentKey (id) {
    return request({
      url: urlBase + '/project/' + id + '/agent_key',
      method: 'get'
    })
  },
  // 重置agent_key
  resetAgentKey (id) {
    return request({
      url: urlBase + '/project/' + id + '/agent_key',
      method: 'put'
    })
  },
  // env配置
  // 获取环境变量列表
  getEnvsList () {
    return request({
      url: urlBase + '/env',
      method: 'get'
    })
  },
  // 创建ENV
  createEnv (data) {
    return request({
      url: urlBase + '/env/create/',
      method: 'post',
      data
    })
  },
  putEnv (data, id) {
    return request({
      url: urlBase + '/env/modify?id=' + id,
      method: 'put',
      data
    })
  },
  deleteEnv (id) {
    return request({
      url: urlBase + '/env/delete?id=' + id,
      method: 'delete',
    })
  },
  getDataRecordDataList () {
    return request({url: urlBase + '/records/data_list', method: 'get'})
  },
  getDataRecords (obj) {
    return request({url: urlBase + '/records/search', method: 'post', data: obj})
  },
  getDataRecord (id) {
    return request({url: urlBase + '/record/' + id, method: 'get'})
  },
  deleteDataRecord (id) {
    return request({url: urlBase + '/record/' + id, method: 'delete'})
  },
  resetDataRecord (id, data) {
    return request({url: urlBase + '/record/' + id + '/reset', method: 'post', data: data})
  },
  passDataRecord (id, data) {
    return request({url: urlBase + '/record/' + id + '/pass', method: 'post', data: data})
  },
  getPipelines (data) {
    return request({
      url: urlBase + '/pipeline' + apiObj(data),
      method: 'get'
    })
  },
  getPipeline (id) {
    return request({
      url: urlBase + '/pipeline/' + id,
      method: 'get'
    })
  },
  getGroupCharge (id) {
    return request({
      url: urlBase + '/pipeline/' + id + '/groupCharge',
      method: 'get'
    })
  },
  getCommonPipeline (id) {
    return request({
      url: urlBase + '/pipeline/' + id + '/common',
      method: 'get'
    })
  },
  delPipeline (id) {
    return request({
      url: urlBase + '/pipeline/' + id,
      method: 'delete'
    })
  },
  postPipeline (data) {
    return request({
      url: urlBase + '/pipeline',
      method: 'post',
      data: data
    })
  },
  putPipeline (data) {
    return request({
      url: urlBase + '/pipeline/' + data.id,
      method: 'put',
      data: data
    })
  },
  putPipelineConfig (data) {
    return request({
      url: urlBase + '/pipeline/' + data.id + '/config',
      method: 'put',
      data: data
    })
  },
  putPipelineSetting (data) {
    return request({
      url: urlBase + '/pipeline/' + data.id + '/setting',
      method: 'put',
      data: data
    })
  },
  runPipeline (id, debug) {
    return request({
      method: 'post',
      url: urlBase + '/pipeline/' + id + '/run?debug=' + debug,
      data: {}
    })
  },
  cancelPipeline (id) {
    return request({
      method: 'post',
      url: urlBase + '/pipeline/' + id + '/cancel',
      data: {}
    })
  },
  getProcs (data) {
    return request({
      url: urlBase + '/procs',
      method: 'post',
      data: data
    })
  },
  getProcsByPID (pid) {
    return request({
      url: urlBase + '/procs/' + pid
    })
  },
  getProc (pid) {
    return request({
      url: urlBase + '/proc/' + pid
    })
  },
  getProcSteps (pid) {
    return request({
      url: urlBase + '/proc/' + pid + '/steps'
    })
  },
  getProcStep (sid) {
    return request({
      url: urlBase + '/proc_step/' + sid
    })
  },
  getTokenList () {
    return request({
      url: urlBase + '/token',
      method: 'get'
    })
  },
  createToken (data) {
    return request({
      url: urlBase + '/token',
      method: 'post',
      data: data
    })
  },
  deleteToken (id) {
    return request({
      url: urlBase + '/token/' + id,
      method: 'delete',
    })
  },

}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js